export enum ChatMode {
    FinancePeerReview = "FinancePeerReview",
    Intranet = "Intranet"
}
